<template>
    <drag-base :w="width" :h="height" :x="parseInt(left)" :y="parseInt(top)" v-on:dragstop="stopDrag"
                           v-on:resizestop="stopResize" :parent="true" :snap-grid="snapGrid">
      <v-hover>
        <div slot-scope="{ hover }" class="stickie"
             :style="{'border': hover? '1px solid lightgrey': '1px solid transparent'}"
             @dblclick="$refs.graphicEditor.showEditor()">
          <v-img v-if="pictureBase64" contain :src="pictureBase64"></v-img>
          <v-card-text class="stickie-content" v-else>
            <v-icon>fa-image</v-icon>
            <span class="caption grey--text">Double Click to select an image.</span>
          </v-card-text>
          <v-card-actions style="height:50px;">
            <v-spacer></v-spacer>
          <v-scroll-y-transition>
              <div v-show="hover & $can('update', 'GraphicalView')">
              <v-tooltip top>
                  <v-btn icon small secondary slot="activator" @click="$refs.graphicEditor.showEditor()">
                    <v-icon>fa-edit</v-icon>
                  </v-btn>
                  <span>Edit this Stickie</span> <!-- background color / delete / content -->
              </v-tooltip>

              <v-tooltip top>
                  <v-btn icon small secondary slot="activator" @click="deleteStickie">
                    <v-icon>fa-trash</v-icon>
                  </v-btn>
                  <span>Delete this Stickie</span> <!-- background color / delete / content -->
              </v-tooltip>
              </div>
          </v-scroll-y-transition>
          </v-card-actions>
        </div>
      </v-hover>
      <edit-graphics :note="note" ref="graphicEditor"></edit-graphics>
  </drag-base>
</template>

<script>
import DragBase from './DragBase'
import EditGraphics from './EditGraphics'
export default {
  name: 'GraphicStickie',
  components: {EditGraphics, DragBase},
  props: {
    pictureBase64: {type: String, default: null},
    left: Number,
    top: Number,
    url: String,
    content: String,
    width: {type: Number, default: 300},
    height: {type: Number, default: 200},
    note: Object,
    id: {},
    snapGrid: {type: Boolean, default: false}
  },
  methods: {
    deleteStickie: function () {
      this.$store.commit('removeStickie', this.id)
    },
    stopResize: function (x, y, width, height) {
      this.x = x
      this.y = y
      this.currentWidth = width
      this.currentHeight = height
      this.updateStore()
    },
    stopDrag: function (x, y) {
      this.x = x
      this.y = y
      this.currentWidth = this.note.width
      this.currentHeight = this.note.height
      this.updateStore()
    },
    updateStore: function () {
      let note = this.note
      note.top = this.y
      note.left = this.x
      note.width = this.currentWidth
      note.height = this.currentHeight
      this.$store.commit('editStickie', note)
    }
  }

}
</script>

<style scoped>
.stickie {
    position: absolute;
    width: 100%;
    height: 100%;

    display: flex;
    flex-flow: column;
  }

  .stickie-content {
    height: 100%;
    width: 100%;
    text-align: left;
  }
</style>
